import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import { DEFAULT_TIMEZONE, TIMEZONE_STORAGE_KEY } from '@/config/timezone'

export const useTimezoneStore = defineStore('timezone', () => {
  // 从 localStorage 读取保存的时区，如果没有则使用默认时区
  const savedTimezone = localStorage.getItem(TIMEZONE_STORAGE_KEY)
  const timezone = ref(savedTimezone || DEFAULT_TIMEZONE)

  // 设置时区
  const setTimezone = (tz: string) => {
    timezone.value = tz
  }

  // 获取当前时区
  const getTimezone = () => {
    return timezone.value
  }

  // 监听时区变化，自动保存到 localStorage
  watch(timezone, (newTimezone) => {
    localStorage.setItem(TIMEZONE_STORAGE_KEY, newTimezone)
  })

  return {
    timezone,
    setTimezone,
    getTimezone
  }
})
